import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddItemCategory from "./AddItemCategory";
import EditItemCategory from "./EditItemCategory";
import DeleteItemCategory from "./DeleteItemCategory";
import ItemCategoryViewModel from "../ItemCategory/ItemCategoryViewModel";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class ItemCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showitemCategoryAddModel: false,
      showitemCategoryEditModel: false,
      showitemCategoryDelModel: false,
      ItemCategoryViewShow: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.itemCategorylist();
    // console.log(this.props.itemCategoryList);
  }
  handleAddItemCategory = () => {
    this.setState({
      showitemCategoryAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showitemCategoryAddModel: false,
    });
  };
  handleEditItemCategory = (item) => {
    this.setState({
      showitemCategoryEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showitemCategoryEditModel: false,
    });
  };
  handleDelItemCategory = (item) => {
    this.setState({
      showitemCategoryDelModel: true,
      DeleteitemCategoryItem: item,
    });
  };
  closeitemCategoryDelModel = () => {
    this.setState({
      showitemCategoryDelModel: false,
    });
  };
  handleItemCategoryView = (item) => {
    this.setState({
      ItemCategoryViewShow: true,
      ItemCategoryDtls: item,
    });
  };

  handleCloseItemCategory = () => {
    this.setState({ ItemCategoryViewShow: false });
  };
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ItemCategorySlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.itemCategoryCount && this.props.itemCategoryCount;
    let ItemCategoryPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Item Category</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddItemCategory()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddItemCategory
                showitemCategoryAddModel={this.state.showitemCategoryAddModel}
                closeAddModel={this.closeAddModel}
                AddItemCategory={this.props.AddItemCategory}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "10px" }}>SL NO</th>
                    <th style={{ width: "100px" }}>NAME</th>
                    <th style={{ width: "150px" }}>DESCRIPTION</th>
                    <th style={{ width: "50px" }}>ACTIVE</th>
                    <th style={{ width: "50px" }}>CREATED DATE</th>
                    <th style={{ width: "50px" }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.itemCategoryList &&
                    this.props.itemCategoryList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.disc}
                        </td>

                        <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleItemCategoryView({
                                  item: item,
                                })
                              }
                            ></i>
                            <ItemCategoryViewModel
                              show={this.state.ItemCategoryViewShow}
                              handleClose={this.handleCloseItemCategory}
                              ItemCategoryDtls={this.state.ItemCategoryDtls}
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditItemCategory(item)}
                            ></i>
                            <EditItemCategory
                              showitemCategoryEditModel={
                                this.state.showitemCategoryEditModel
                              }
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditItemCategory={this.props.EditItemCategory}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelItemCategory(item)}
                            ></i>
                            <DeleteItemCategory
                              showitemCategoryDelModel={
                                this.state.showitemCategoryDelModel
                              }
                              closeitemCategoryDelModel={
                                this.closeitemCategoryDelModel
                              }
                              DeleteitemCategoryItem={
                                this.state.DeleteitemCategoryItem
                              }
                              DeleteItemCategory={this.props.DeleteItemCategory}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.itemCategoryList === undefined ||
                (this.props.itemCategoryList &&
                  this.props.itemCategoryList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Categories Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {ItemCategoryPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={ItemCategoryPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default ItemCategory;
